import createBreakpoint from 'shared-tokens/utils/breakpoints';

export const mainCls = 'grid-item';

const countDec = (value) => {
    if (Math.floor(value) === value) return 0;
    return value.toString().split('.')[1].length || 0;
}

const createGridColumns = (selector, media) => {
    const result = {};
    const max = 12;
    const withMedia = style => media ? { [media]: style } : style;

    for (let i = 1; i <= max; i++) {
        const num = (i / 12) * 100;
        const numRes = countDec(num) > 3 ? num.toFixed(3) : num;
        const width = `${numRes}%`;
        result[`${selector}-${i}`] = withMedia({
            width,
            maxWidth: width,
            flexBasis: width,
        });
    }

    result[`${selector}-auto`] = withMedia({
        width: 'auto',
        maxWidth: 'none',
        flexBasis: '0%',
    });

    return result;
}

export default {
    [mainCls]: {
        flex: '1 1 0%',
    },
    ...[
        ['fixed', '0 1 auto'],
        ['stretch', '1 1 auto'],
        ['no-shrink', '1 0 auto'],
    ].reduce((acc, item) => {
        acc[`${mainCls}--behavior-${item[0]}`] = { flex: item[1] };
        return acc;
    }, {}),
    ...[
        ['top', 'flex-start'],
        ['middle', 'center'],
        ['bottom', 'flex-end'],
    ].reduce((acc, item) => {
        acc[`${mainCls}--align-${item[0]}`] = { alignSelf: item[1] };
        return acc;
    }, {}),
    ...[
        'top', 'right', 'bottom', 'left'
    ].reduce((acc, item) => {
        acc[`${mainCls}--push-${item}`] = { [`margin-${item}`]: 'auto' };
        return acc;
    }, {}),
    ...createGridColumns(`${mainCls}--cols`),
    ...createGridColumns(`${mainCls}--sm`, createBreakpoint('s')),
    ...createGridColumns(`${mainCls}--md`, createBreakpoint('m')),
    ...createGridColumns(`${mainCls}--lg`, createBreakpoint('l')),
};